import './styles.css';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../components/Accessibility/DefaultText';
import { sxCheckbox } from './sxProps';
import {  Checkbox, FormControlLabel } from '@mui/material';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import { useEffect, useState } from 'react';
import { aceiteNaoMostrarNovamente, getEmQualNivelMeEncontro, getMostrarNovamenteNivel } from '../../../services/SaudeBemEstar/SaudeEmocionalService';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxCheckboxContrast } from '../../../assets/styles/CommonSxProps';
import { RetornaAceiteTermoResponse } from '../../../interfaces/entities/RetornaAceiteTermoResponse';
import { AutoAvaliacaoInfoPage } from './AutoAvaliacaoInfo';

const AutoAvaliacaoInfo1: React.FC<AutoAvaliacaoInfoPage> = ({onBack, onNext}) => {
  const accessibility = useAccessibility()
  const [text, setText] = useState<string[]>([])
  const [images, setImages] = useState<string[]>([])
  const [checked, setChecked] = useState<boolean>(false);
  const [acceptTerms, setAcceptTerms] = useState<RetornaAceiteTermoResponse | null>(null);

  useEffect(() => {
    getMostrarNovamenteNivel().then((response) => {
      setAcceptTerms(response)
    })
  }, [])

  const handleNext = async () => {
    if (acceptTerms !== null && checked) {
      await aceiteNaoMostrarNovamente(acceptTerms.idTermoResponsabilidade, acceptTerms.idOperador)
    }
    onNext()
  }

  const handleDontShow = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    getEmQualNivelMeEncontro()
      .then(response => {
        setText(response.texto);
        setImages(response.images)
      })
      .catch(error => console.log)
  }, []);

  return (
    <div className='page-container'>
      <PageTitle text="Depressão, ansiedade e estresse: em qual nível me encontro" />

      <div className="max-width-660 flex-col gap-20">
        {
          images.map((img, i) => (
            <img className="width-100-pc" key={i} src={img.replace("data:image/svg;base64,", "data:image/svg+xml;base64,")} alt="agendamento" />
          ))
        }
        {
          text.map((t, i) => (
            <DefaultText key={i} text={t} />
          ))
        }
      </div>

      <DefaultButton onClick={handleNext} text="Continuar" />

      <div className='flex-row'>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleDontShow}
              style={accessibility.contrastColorAccessibility} />
          }
          label="Não exibir mais esta tela"
          sx={accessibility.contrastMode ? sxCheckboxContrast : sxCheckbox} />
      </div>

      <VoltarButton onClick={onBack} />

    </div>
  )
}

export default AutoAvaliacaoInfo1;